export default __webpack_public_path__ + "static/media/client-25.c5be3652.png";